import React, {Component} from 'react';
import { array, any, object } from 'prop-types'

import NewItemForm from '../../submitItemForm';
import JewelryBoxForm from '../../submitJewelryBoxForm';


class HomePageSubmissionForm extends Component{
  constructor(props){
    super(props);

    this.state = {
      showRingForm: true,
      showJewelryBoxForm: false
    };

    this.onClick = this.onClick.bind(this);
  }

  static propTypes = {
    tabs: array,
    componentRef: any,
    location: object
  };

  renderJeweleryIcon(){
    return (
        <svg className='jewelerySvg svg' width="41" height="29" viewBox="0 0 41 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.7066 21.4983V21.1664L16.0124 21.0375C16.6008 20.7897 16.9789 20.2616 16.9789 19.6658C16.9789 18.8422 16.2775 18.1438 15.3494 18.1438C14.408 18.1438 13.7066 18.8548 13.7066 19.6658C13.7066 20.2631 14.0864 20.7916 14.6626 21.0388L14.9655 21.1687V21.4983V22.9867C14.9655 23.1386 15.1023 23.3082 15.336 23.3082C15.5698 23.3082 15.7066 23.1386 15.7066 22.9867V21.4983Z" fill="#F5A723" stroke="#F5A723"/>
        <path d="M39.6138 8.45898V22.4521L31.2301 27.5069L1.48948 27.4453V13.6987L30.7406 13.7604L39.6138 8.45898Z" stroke="#F5A723" strokeWidth="2" strokeMiterlimit="10"/>
        <path d="M39.6138 8.45892C39.6138 8.45892 40.1646 1.6781 34.4123 1.61645C14.7687 1.49316 9.50599 1.49316 9.50599 1.49316C9.50599 1.49316 1.42829 2.04796 1.48948 13.6986" stroke="#F5A723" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
        <path d="M30.7406 13.7603V27.0753" stroke="#F5A723" strokeWidth="2" strokeMiterlimit="10"/>
        <path d="M30.7406 13.7604C30.7406 13.7604 30.1899 0.753509 35.881 1.67817" stroke="#F5A723" strokeWidth="2" strokeMiterlimit="10"/>
        </svg>
     )
  }

  renderRingIcon(){
      return (
          <svg className='ring svg' width="49" height="29" viewBox="0 0 49 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31.8749 14.5778C40.489 13.6159 46.6317 11.108 46.6317 8.16558C46.6317 4.39232 36.5301 1.3335 24.0692 1.3335C11.6082 1.3335 1.50665 4.39232 1.50665 8.16558C1.50665 11.0371 7.75301 13.5671 16.0415 14.5778" stroke="#F5A723" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
            <path d="M1.50667 8.16553C0.366667 12.868 1.50667 15.6547 1.50667 15.6547C2.31531 18.4939 7.68334 20.948 15.6458 21.9743" stroke="#F5A723" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
            <path d="M46.6317 8.16553C47.7717 12.868 46.6317 15.6547 46.6317 15.6547C45.8156 18.5202 40.3552 20.9934 32.2708 22.0024" stroke="#F5A723" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
            <path d="M24.0692 27.2369C28.7694 27.2369 32.5796 23.4267 32.5796 18.7265C32.5796 14.0263 28.7694 10.2161 24.0692 10.2161C19.369 10.2161 15.5588 14.0263 15.5588 18.7265C15.5588 23.4267 19.369 27.2369 24.0692 27.2369Z" stroke="#F5A723" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M25 13.4905V10H23V13.4905L18.8912 16.4756L16.4693 15.1885L15.5307 16.9546L18.5525 18.5605L20.0489 23.1658L17.9 25.7999L19.5 26.9999L21.9105 24.0451H26.0338L28.4 27.2L30 26L27.928 23.2372L29.525 18.3219L32.0979 16.9546L31.1593 15.1885L28.9519 16.3616L25 13.4905ZM21.7876 22.0451L20.4203 17.8369L24 15.2361L27.5797 17.8369L26.2124 22.0451H21.7876Z" fill="#F5A723"/>
          </svg>
      )
  }

  onClick(e) {
    let target = e.currentTarget;
    let form = target.querySelector('.tab').getAttribute('data-form');
    let isJewelryBoxForm = form === 'showRingForm';
    let propsToUpdate = {
      showRingForm: false,
      showJewelryBoxForm: true
    };

    if (isJewelryBoxForm) {
      propsToUpdate = {
        showRingForm: true,
        showJewelryBoxForm: false
      };
    }

    this.setState(propsToUpdate);
  }

  render() {
      let tabs = this.props.tabs.map((tab,idx) => {
        const {text,attr} = tab;
        const structureProps = {className:`tab-structure ${this.state[attr['data-form']] ? 'active' : ''}` };
        const icon = `render${text}Icon`;

        return <div {...structureProps} key={idx} onClick={this.onClick} ref={this.props.componentRef}>
                <div {...attr}>
                  <div className="icon">{this[icon]()}</div>
                  <div className="text">{text}</div>
                </div>
               <div className="rounded-border"/>
            </div>
      });

      return <React.Fragment>
        <div className="tabs">{tabs}</div>
        {this.state.showRingForm ? <NewItemForm params={{itemType: 'ring'}}  submissionOnHomePage={true}/> : null}
        {this.state.showJewelryBoxForm ? <JewelryBoxForm submissionOnHomePage={true} location={this.props.location}/> : null}
      </React.Fragment>;
    }
}

export default HomePageSubmissionForm;
